<div class="visitor-registration-summary">
  <sc-title>
    <sc-dictionary-label
    dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.title"></sc-dictionary-label>
  </sc-title>

  @if (isUsingSmartphone) {
    <p>
      <sc-dictionary-label
      dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.description"></sc-dictionary-label>
    </p>
  }

  <mat-card>
    <table>
      <tr>
        <td class="label"><label>
          <sc-dictionary-label
          dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.numberPlate"></sc-dictionary-label>:</label>
        </td>
        <td class="bold">{{numberPlate}}</td>
      </tr>
      <tr>
        <td class="label"><label>
          <sc-dictionary-label
          dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.company"></sc-dictionary-label>:</label>
        </td>
        <td class="bold">{{company}}</td>
      </tr>
      <tr>
        <td class="label"><label>
          <sc-dictionary-label
          dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.name"></sc-dictionary-label>:</label>
        </td>
        <td class="bold">{{name}}</td>
      </tr>
      <tr>
        <td class="label"><label>
          <sc-dictionary-label
          dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.firstname"></sc-dictionary-label>:</label>
        </td>
        <td class="bold">{{firstname}}</td>
      </tr>
    </table>
    @if (hasSummaryHints()) {
      <sc-content-spacer vertical></sc-content-spacer>
      <div class="hint">
        <sc-dictionary-label
        dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.hints"></sc-dictionary-label>
      </div>
    }
    @for (infoText of informationTexts; track infoText; let first = $first) {
      <sc-content-spacer vertical></sc-content-spacer>
      <div class="hint">
        <sc-padding>
          <sc-dictionary-label [dictionaryKey]="infoText"></sc-dictionary-label>
        </sc-padding>
      </div>
    }
    @if (showHintForGrandAreaAccessByCar) {
      <sc-content-spacer vertical></sc-content-spacer>
      <div class="hint">
        <sc-padding>
          <sc-dictionary-label [dictionaryKey]="accessByCarHintDictionaryKey"></sc-dictionary-label>
        </sc-padding>
      </div>
    }
  </mat-card>

  @if (this.translationService.translationExists('tmc-yard.widgets.registration-terminal.visitor-registration-summary.info', this.translationService.language)) {
    <h1
      >
      <sc-dictionary-label
      dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.info"></sc-dictionary-label>
    </h1>
  }

  <div class="success">
    <sc-flex centered>
      <i class="fa-light fa-sharp fa-check-circle"></i>
    </sc-flex>
  </div>

  @if (gatekeeperMandatory) {
    <p class="gatekeeper-hint">
      <sc-dictionary-label
      dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-registration-summary.hint"></sc-dictionary-label>
    </p>
  }
</div>
